/**
 * @namespace Captcha
 * @aka SWR.Captcha
 */
SWR.Captcha = (function ($) {

  var isactive = false;
  var thequestion = '';
  var questionId = null;
  var captchaTrials = 0;
  var formType = "form";

  /**
   * --------------------------------------------------------------------------
   * Public Util Api
   * --------------------------------------------------------------------------
   */

  var Captcha = {
    init: function init($target, type) {
      formType = type || "form";
      console.log(formType);

      if (captchaTrials > 3) {
        console.error('captcha could not be loaded');
        $target.trigger('swr:captcha:loadingerror');
        return;
      }

      captchaTrials++;

      $.ajax({
        url: 'https://www.swr.de/system/servlet/captcha.servlet',
        dataType: 'json',
        crossDomain: true
      }).done(function (data, textStatus, jqXHR) {
        if (!data.hasOwnProperty('id') || null === data.id) {
          return;
        }
        if (!data.hasOwnProperty('question') || null === data.question) {
          return;
        }

        isactive = true;
        questionId = data.id;
        thequestion = data.question;

        if(formType === "comments"){
          captchaTrials = 0;
        }

        $target.trigger('swr:captcha:loaded');

      }).fail(function (jqXHR, textStatus, errorThrown) {
        // no captcha
        console.error('captcha could not be loaded');
        init();
      });
    },
    id: function id() {
      return questionId;
    },
    active: function active() {
      return isactive;
    },
    question: function question() {
      return thequestion;
    }
  };

  return Captcha;

})(window.jQuery);
